package one.healthium.onboarding.domain

class OnboardingInteractor(
    private val repository: OnboardingRepository
) {
    suspend fun get(): OnboardingModel = repository.get()
}

interface OnboardingRepository {
    suspend fun get(): OnboardingModel
}
